import { useEffect, useState } from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Hub } from 'aws-amplify/utils';
import { Spinner } from '../components/ui/spinner';
import { useTranslation } from '../i18n/I18nContext';

const AuthCallback: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hubListener = Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signedIn':
          hubListener();
          navigate('/articles', { replace: true });
          break;

        case 'signInWithRedirect_failure':
          console.error('[AuthCallback] OAuth authentication failed:', payload.data);
          hubListener();
          setError(t('auth.callback_failed'));
          break;
      }
    });

    const timeoutHandler = setTimeout(() => {
      hubListener();
      setError(t('auth.callback_timeout'));
    }, 15000);

    return () => {
      clearTimeout(timeoutHandler);
      hubListener();
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-5">
        <div className="text-center max-w-md">
          <div className="text-4xl mb-4">⚠</div>
          <h2 className="text-2xl font-bold mb-3">{t('auth.callback_error_title')}</h2>
          <p className="text-muted-foreground mb-6">{error}</p>
          <button
            onClick={() => navigate('/auth')}
            className="bg-success text-success-foreground px-6 py-3 rounded font-semibold hover:opacity-90"
          >
            {t('auth.try_again')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6">
      <Spinner className="h-10 w-10" />
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">{t('auth.callback_completing')}</h2>
        <p className="text-muted-foreground">{t('auth.callback_processing')}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
